import gql from 'graphql-tag';

const sendRequestFeatureAccessEmailMutation = gql`
  mutation Web_Profiles_SendRequestFeatureAccessEmail_r1($input: RequestFeatureAccessInput!) {
    sendRequestFeatureAccessEmail(input: $input)
  }
`;

export default sendRequestFeatureAccessEmailMutation;
